import React from 'react';
import { Box, Flex, Icon, Text, IconButton, Heading, Label, Divider } from '@vibe/core';
import { AppModal, AppModalContent } from '@gorilla/ui/src/components/AppModal';
import { NewTab, AddSmall, Baseline, Link, TextFormatting, Embed, Pin, Workspace, Table } from '@vibe/icons';
import { coreSectionDescriptors } from '@gorilla/portal-shared/src/core-sections';
import { SectionIcon } from './SectionMeta';
import { ExternalLink } from './ExternalLink';

type SectionsModalProps = {
  onClose: () => void;
  addSection: (sectionDescriptor: any) => void;
};

export function SectionsModal({ onClose, addSection }: SectionsModalProps) {
  return (
    <AppModal show={true} onClose={onClose} contentSpacing={false} alertDialog={false} width={450} id="sections__modal">
      <AppModalContent>
        <div style={{ overflow: 'hidden' }}>
          <Flex direction="row" align="center" gap={10}>
            <Icon icon={NewTab} size={24} style={{ transform: 'translate3d(0,-1px,0)' }} />
            <Heading type="h3" weight="bold" align="start">
              Sections
            </Heading>
          </Flex>

          <Box
            rounded="small"
            border={true}
            borderColor="layoutBorderColor"
            style={{
              overflowY: 'auto',
              margin: '24px 0 10px 0',
              width: 'calc(100% - 2px)',
              height: 'auto',
              maxHeight: 'calc(100vh - 200px)',
            }}
          >
            <Flex direction="column">
              <div style={{ width: '100%' }}>
                {coreSectionDescriptors.map((coreSectionDescriptor, index) => {
                  return (
                    <React.Fragment key={`${coreSectionDescriptor.type}`}>
                      <div
                        onClick={() => {
                          addSection(coreSectionDescriptor);
                          onClose();
                        }}
                        style={{
                          width: '100%',
                          cursor: 'pointer',
                        }}
                      >
                        <Flex
                          gap={16}
                          style={{
                            position: 'relative',
                            padding: '12px 18px',
                            width: 'calc(100% - 36px)',
                            height: '100%',
                          }}
                          className="section__card"
                        >
                          <Box style={{ flex: 1 }}>
                            <Flex gap={16} direction="row" justify="start" align="center">
                              <Flex gap={2} direction="column" justify="start" align="start" style={{ flex: 1 }}>
                                <Flex gap={8} align="center">
                                  <Text type="text2" color="primary" weight="bold" align="start" ellipsis={false}>
                                    {coreSectionDescriptor.title}
                                  </Text>
                                  {coreSectionDescriptor.type === 'client-item-summary' ? (
                                    <div style={{ transform: 'translate3d(0,-1.5px,0)' }}>
                                      <Label
                                        text="Linked to Clients Board"
                                        size="small"
                                        kind="line"
                                        color="dark"
                                        className="custom_small_label"
                                      />
                                    </div>
                                  ) : null}
                                </Flex>
                                <Text type="text2" color="secondary" align="start" ellipsis={false}>
                                  {coreSectionDescriptor.description}
                                </Text>
                              </Flex>
                            </Flex>
                          </Box>
                          <Flex
                            justify="center"
                            align="center"
                            style={{
                              position: 'relative',
                              width: '32px',
                              height: '100%',
                            }}
                          >
                            <SectionIcon sectionType={coreSectionDescriptor.type} />

                            <div className="section__card__cta">
                              <IconButton icon={AddSmall} kind="primary" size="small" color="primary" />
                            </div>
                          </Flex>
                        </Flex>
                      </div>
                      {index < coreSectionDescriptors.length - 1 ? <Divider withoutMargin /> : null}
                    </React.Fragment>
                  );
                })}
              </div>
            </Flex>
          </Box>

          <Text type="text2" align="start" color="secondary" element="p" style={{ marginTop: '24px', marginBottom: '8px' }}>
            Mix and match different content sections on a portal page.{' '}
            <ExternalLink href="https://getgorilla.app/products/client-portal/docs/features/builder/content-sections" target="_blank">
              Learn more
            </ExternalLink>
          </Text>
        </div>
      </AppModalContent>
    </AppModal>
  );
}
